import type { ReactNode } from 'react'
import React from 'react'

import * as S from './SectionDescription.styled'

export type SectionDescriptionProps = {
  children: ReactNode
}

export const SectionDescription = ({ children }: SectionDescriptionProps) => (
  <S.Container>{children}</S.Container>
)
